export default "__VITE_ASSET__524a5799__"